import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../common/material/material.module';
import { ServiceModule } from '../../service/service.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErzeugungsanlageRoutingModule } from '../erzeugungsanlage-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalDirectivesModule } from '../../common/form/validation/global-directives.module';
import { ErzeugungsanlageDetailFormComponent } from './erzeugungsanlage-detail-form/erzeugungsanlage-detail-form.component';
import { NetzzuordnungSubFormComponent } from './netzzuordnung-sub-form/netzzuordnung-sub-form.component';
import { AnlagenAnschriftSubFormComponent } from './anlagen-anschrift-sub-form/anlagen-anschrift-sub-form.component';
import { GeokoordinatenSubFormComponent } from './geokoordinaten-sub-form/geokoordinaten-sub-form.component';
import { AbregelungSubFormComponent } from './abregelung-sub-form/abregelung-sub-form.component';
import { MarktlokationSubFormComponent } from './marktlokation-sub-form/marktlokation-sub-form.component';
import { BetriebSubFormComponent } from './betrieb-sub-form/betrieb-sub-form.component';
import { AbrechnungSubFormComponent } from './abrechnung-sub-form/abrechnung-sub-form.component';
import { SolarSubFormComponent } from './solar-sub-form/solar-sub-form.component';
import { WindSubFormComponent } from './wind-sub-form/wind-sub-form.component';
import { BatteriespeicherSubFormComponent } from './batteriespeicher-sub-form/batteriespeicher-sub-form.component';
import { SteuerbareResourceSubFormComponent } from './steuerbare-resource-sub-form/steuerbare-resource-sub-form.component';
import { TechnischeResourceSubFormComponent } from './technische-resource-sub-form/technische-resource-sub-form.component';
import { AbregelinformationenIec101104AdresseComponent } from './abregelung-sub-form/abregelinformationen-iec101104-detail/abregelinformationen-iec101104-adresse/abregelinformationen-iec101104-adresse.component';
import { AbregelinformationenTase2DetailComponent } from './abregelung-sub-form/abregelinformationen-tase2-detail/abregelinformationen-tase2-detail.component';
import { AbregelinformationenTase2AdresseComponent } from './abregelung-sub-form/abregelinformationen-tase2-detail/abregelinformationen-tase2-adresse/abregelinformationen-tase2-adresse.component';
import { AbregelinformationenIec101104DetailComponent } from './abregelung-sub-form/abregelinformationen-iec101104-detail/abregelinformationen-iec101104-detail.component';
import { AnlagenkennlinieSubFormComponent } from './wind-sub-form/anlagenkennlinie-sub-form/anlagenkennlinie-sub-form.component';
import { ErzeugungsanlageFormPrefixComponent } from './erzeugungsanlage-form-prefix/erzeugungsanlage-form-prefix.component';
import { ResourceIdsSubFormComponent } from './resource-ids-sub-form/resource-ids-sub-form.component';
import { TrancheSubFormComponent } from './tranche-sub-form/tranche-sub-form.component';
import { FormComponentsModule } from '../../common/form/components/form-components.module';

@NgModule({ declarations: [
    ErzeugungsanlageDetailFormComponent,
    NetzzuordnungSubFormComponent,
    AnlagenAnschriftSubFormComponent,
    GeokoordinatenSubFormComponent,
    AbregelungSubFormComponent,
    AbregelinformationenTase2DetailComponent,
    AbregelinformationenTase2AdresseComponent,
    AbregelinformationenIec101104DetailComponent,
    AbregelinformationenIec101104AdresseComponent,
    AbregelungSubFormComponent,
    AbregelungSubFormComponent,
    AbregelungSubFormComponent,
    MarktlokationSubFormComponent,
    BetriebSubFormComponent,
    AbrechnungSubFormComponent,
    SolarSubFormComponent,
    WindSubFormComponent,
    BatteriespeicherSubFormComponent,
    SteuerbareResourceSubFormComponent,
    TechnischeResourceSubFormComponent,
    AnlagenkennlinieSubFormComponent,
    ErzeugungsanlageFormPrefixComponent,
    ResourceIdsSubFormComponent,
    TrancheSubFormComponent,
],
exports: [
    ErzeugungsanlageDetailFormComponent,
], imports: [
    CommonModule,
    MaterialModule,
    ServiceModule,
    ErzeugungsanlageRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    GlobalDirectivesModule,
    FormComponentsModule,
], providers: [
    provideHttpClient(withInterceptorsFromDi()),
] })
export class ErzeugungsanlageFormModule {
}
